// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/personal-logbook-requirements.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/personal-logbook-requirements/personal-logbook-requirements.js';

mount([g0]);
